// ReportHeaderPlanner Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Util from '../../../lib/util.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import DateFilterTab from '../../layout/date_filtertab/date_filtertab.jsx'

class ReportHeaderEmployeeProductivity extends Component {
  constructor (props) {
    super(props)

    this.data = {
      filterType: props.filterType || 'week',
      fromDate: props.fromDate,
      toDate: props.toDate,
      graphFromDate: props.graphFromDate,
      graphToDate: props.graphToDate
    }
  }

  static get propTypes () {
    return {
      filterType: PropTypes.string,
      filterTypes: PropTypes.array,
      fromDate: PropTypes.object,
      toDate: PropTypes.object,
      graphFromDate: PropTypes.object,
      graphToDate: PropTypes.object,
      onChangeFilterType: PropTypes.func,
      onNavigate: PropTypes.func,
      onChangeFilter: PropTypes.func,
      isPlannerAllowed: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      filterType: '',
      filterTypes: [],
      fromDate: null,
      toDate: null,
      graphFromDate: null,
      graphToDate: null,
      onChangeFilterType: null,
      onNavigate: null,
      onChangeFilter: null,
      isPlannerAllowed: false
    }
  }

  render () {
    const { isPlannerAllowed } = this.props
    return (
      <div className='report-header-planner'>
        {isPlannerAllowed && (
          <div className='colleft'>
            <div className='yearrow'>
              {this._renderMonthInfo()}
              <div className='yearcontrols'>
                <IconButton
                  className='action headeraction'
                  size='normal'
                  type='normal'
                  icon='planner-toolbar-previous'
                  canHover={false}
                  onClick={this._onNavigate.bind(this, false)}
                />
                <IconButton
                  className='action actionnext'
                  size='normal'
                  type='normal'
                  icon='planner-toolbar-next'
                  canHover={false}
                  onClick={this._onNavigate.bind(this, true)}
                />
              </div>
            </div>
          </div>
        )}
        {isPlannerAllowed && (
          <div className='colright'>
            <DateFilterTab
              type={this.props.filterType}
              onChange={this._onChangeFilterType.bind(this)}
            />
          </div>
        )}
      </div>
    )
  }

  /* Private function */
  _addDaysToDate (date, incrDays) {
    return new Date(date.getTime() + 1000 * incrDays * 24 * 60 * 60)
  }

  /* Event handler */
  _onChangeFilterType (value) {
    const { fromDate, toDate } = this.props
    const currDate = new Date(fromDate || toDate || new Date())
    let graphFromDate = new Date(currDate.getFullYear(), 0, 1)
    let graphToDate = new Date(currDate.getFullYear(), 11, 31, 23, 59, 59)

    if (value === 'week') {
      const currWeekNo = DateUtil.getLocalWeekNo(currDate)
      graphFromDate = Util.getMondayByWeek(currDate.getFullYear(), currWeekNo)
      graphFromDate.setHours(0, 0, 0, 0)
      graphToDate = DateUtil.addDaysToDate(graphFromDate, 6)
      graphToDate.setHours(23, 59, 59, 0)
    } else if (value === 'month') {
      graphFromDate = new Date(currDate.getFullYear(), currDate.getMonth(), 1)
      graphToDate = new Date(
        currDate.getFullYear(),
        currDate.getMonth() + 1,
        0,
        23,
        59,
        59
      )
    }

    this.data.filterType = value
    this.data.graphFromDate = graphFromDate
    this.data.graphToDate = graphToDate
    this.forceUpdate()

    this._onChangeFilter()
  }

  /* Event handlers */
  _onNavigate (bNext, _ev) {
    let { graphFromDate, graphToDate, filterType } = this.data
    const incr = bNext ? 1 : -1

    if (filterType === 'week') {
      graphFromDate = new Date(
        graphFromDate.setDate(graphFromDate.getDate() + incr)
      )
      graphToDate = new Date(graphToDate.setDate(graphToDate.getDate() + incr))
    } else if (filterType === 'month') {
      graphFromDate = new Date(
        graphFromDate.setDate(graphFromDate.getDate() + incr * 7)
      )
      graphToDate = new Date(
        graphToDate.setDate(graphToDate.getDate() + incr * 7)
      )
    } else if (filterType === 'year') {
      graphFromDate = new Date(
        graphFromDate.setMonth(graphFromDate.getMonth() + incr)
      )
      graphToDate = new Date(
        graphToDate.setMonth(graphToDate.getMonth() + incr)
      )
    }

    this.data.graphFromDate = graphFromDate
    this.data.graphToDate = graphToDate

    this._onChangeFilter()
    this.forceUpdate()
  }

  /* Private functions */
  _renderMonthInfo () {
    const { fromDate, toDate } = this.data
    return (
      <div className='currentyear'>
        <h1 className='title'>
          <IntlMessage ident='report.header.yearTitle' />
          {fromDate.getFullYear()}
        </h1>
        <span className='info'>
          <IntlMessage ident='report.header.labelFrom' />
          {` ${DateUtil.getDisplayDate(fromDate)}`}
          <IntlMessage ident='report.header.labelTo' />
          {` ${DateUtil.getDisplayDate(toDate)}`}
        </span>
      </div>
    )
  }

  _onChangeFilter () {
    if (this.props.onChangeFilter) {
      const { graphFromDate, graphToDate, filterType } = this.data

      this.props.onChangeFilter({
        filterType: filterType,
        graphFromDate: graphFromDate,
        graphToDate: graphToDate
      })
    }
  }
}

export default ReportHeaderEmployeeProductivity
